import { SubPackageSlugEnum } from '@yaotai/common-utils';

export const DEFAULT_LOGIN_TARGE_PATH = `${window.location.origin}/${SubPackageSlugEnum.Center}/user`;
